import { useCallback } from 'react';

import { useOriginSource } from './useOriginSource';

export const useOriginClick = (source: string, category: string) => {
  const { setOrigin } = useOriginSource();

  return useCallback(() => {
    setOrigin({ source, category });
  }, [setOrigin, source, category]);
};
